window.TV2 = window.TV2 || {};

window.TV2.initSlideshow = (id) => {
  const container = document.getElementById(`tv2-contentbox-slideshow-${id}`);
  if (!container) return;

  const elements = container.querySelectorAll(".slideshow-image");
  const numElement = container.querySelector(".slideshow__num");
  const captionElements = container.querySelectorAll(".image__figcaption");
  const captionButtons = container.querySelectorAll(
    ".slideshow-image__readmore"
  );
  let index = 0;

  const nextprev = (current, step) =>
    (((current + step) % elements.length) + elements.length) % elements.length;

  const isEllipsisActive = (elm) => elm.offsetWidth < elm.scrollWidth;

  const displayByIndex = (i) => {
    const prev = nextprev(i, -1);
    const next = nextprev(i, 1);
    elements[index].classList.add("slideshow-image--hidden");
    elements[i].classList.remove("slideshow-image--hidden");

    if (
      elements[i].querySelector(".image__figcaption") &&
      !elements[i].className.includes("slideshow-image--show-caption")
    ) {
      if (!isEllipsisActive(elements[i].querySelector(".image__figcaption"))) {
        elements[i]
          .querySelector(".slideshow-image__readmore")
          .classList.add("slideshow__navbutton--hidden");
      } else {
        elements[i]
          .querySelector(".slideshow-image__readmore")
          .classList.remove("slideshow__navbutton--hidden");
      }
    }

    if (elements[next].querySelector("img.lazyload"))
      elements[next].querySelector("img.lazyload").classList.add("lazypreload");
    if (elements[prev].querySelector("img.lazyload"))
      elements[prev].querySelector("img.lazyload").classList.add("lazypreload");

    index = i;

    numElement.innerHTML = `${i + 1} / ${elements.length}`;
  };

  const navigate = (step) => {
    displayByIndex(
      (((index + step) % elements.length) + elements.length) % elements.length
    ); // Actual modulo
  };

  const displayCapByIndex = (i) =>
    elements[i] &&
    elements[i].classList.toggle("slideshow-image--show-caption");

  // Init
  if (elements.length > 0) {
    displayByIndex(0);
    container.removeAttribute("style");
    container.classList.remove("slideshow--loading");
  }

  // Event handlers
  const previousButton = container.querySelector(".slideshow__navbutton--left");
  const nextButton = container.querySelector(".slideshow__navbutton--right");

  previousButton.addEventListener("click", () => navigate(-1));
  nextButton.addEventListener("click", () => navigate(1));

  captionElements.forEach((cap, i) => {
    cap.addEventListener("click", () => displayCapByIndex(i));
  });
  captionButtons.forEach((but, i) => {
    but.addEventListener("click", () => displayCapByIndex(i));
  });
};
